import React from 'react';

function PadlockIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 20">
      <path d="M9.18,11.37H8.81a.66.66,0,0,0-.65.66v2.51a.66.66,0,0,0,.65.66h.37A.66.66,0,0,0,9.64,15a.68.68,0,0,0,.19-.47V12A.66.66,0,0,0,9.18,11.37Z" />
      <path d="M15.54,7h-.61V6.37a5.93,5.93,0,1,0-11.86,0V7h-.6A1.57,1.57,0,0,0,.89,8.55V18a1.57,1.57,0,0,0,1.57,1.57H15.54A1.57,1.57,0,0,0,17.11,18V8.55A1.57,1.57,0,0,0,15.54,7ZM4.78,6.11a4.25,4.25,0,0,1,8.5.26c0,.12,0,.24,0,.35l0,.23L13,7H4.77Zm10.66,10.8a1,1,0,0,1-1,1H3.54a1,1,0,0,1-1-1V9.65a1,1,0,0,1,1-1H14.46a1,1,0,0,1,1,1Z" />
    </svg>
  );
}

export default PadlockIcon;
